import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { useLocation, Link as RouterLink } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();

  const generateBreadcrumbItems = () => {
    const pathnames = location.pathname.split("/").filter((x) => x);
  
    return pathnames.map((segment, index) => {
      const to = `/${pathnames.slice(0, index + 1).join("/")}`;
      const isLast = index === pathnames.length - 1;
  
      // Special case: redirect Funds and Tasks to default sub-paths
      if (segment === "funds") {
        const defaultFundsPath = "/funds/active"; // Redirect to funds/active
        return (
          <BreadcrumbItem key={to}>
            <BreadcrumbLink as={RouterLink} to={defaultFundsPath}>
              Funds
            </BreadcrumbLink>
          </BreadcrumbItem>
        );
      }
  
      if (segment === "tasks") {
        const defaultTasksPath = "/tasks/pending"; // Redirect to tasks/pending
        return (
          <BreadcrumbItem key={to}>
            <BreadcrumbLink as={RouterLink} to={defaultTasksPath}>
              Tasks
            </BreadcrumbLink>
          </BreadcrumbItem>
        );
      }
  
      // Redirect "investment" to the Investments tab in SingleFund
      if (segment === "investment") {
        const fundName = pathnames[index - 1]; // Get the fundName from the previous segment
        const investmentsTabPath = `/funds/${fundName}#investments`; // Anchor link to the Investments tab
        return (
          <BreadcrumbItem key={to}>
            <BreadcrumbLink as={RouterLink} to={investmentsTabPath}>
              Investments
            </BreadcrumbLink>
          </BreadcrumbItem>
        );
      }
  
      // Default behavior for other segments
      return (
        <BreadcrumbItem key={to} isCurrentPage={isLast}>
          {isLast ? (
            <BreadcrumbLink as="span" color="brand.700" fontWeight="500">
              {segment.replace(/-/g, " ").charAt(0).toUpperCase() +
                segment.replace(/-/g, " ").slice(1)}
            </BreadcrumbLink>
          ) : (
            <BreadcrumbLink as={RouterLink} to={to}>
              {segment.replace(/-/g, " ").charAt(0).toUpperCase() +
                segment.replace(/-/g, " ").slice(1)}
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>
      );
    });
  };
  

  return (
    <Breadcrumb separator=">" fontSize="sm" color="gray.600">
      {generateBreadcrumbItems()}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
